import { Table, TableBody, TableCell, TableHead, TableRow } from '@procurify/ui'

import {
  type ConversationDetailTableBlock,
  type ConversationDetailTableColumn,
} from '../../value-objects/ConversationTurnItem'
import { ConversationRichText } from '../ConversationRichText'

export interface ICatalogItemDetailsTableBlockProps {
  block: ConversationDetailTableBlock
}

const alignForColumn = (column?: ConversationDetailTableColumn) =>
  column?.align === 'end' ? 'right' : 'left'

export const CatalogItemDetailsTableBlock = ({
  block,
}: ICatalogItemDetailsTableBlockProps) => {
  const hasHeader = block.columns.some((column) => column.label)

  const rows = block.rows.map((row) => ({
    key: row.join('-'),
    cells: row.map((cell, columnIndex) => ({
      cell,
      column: block.columns[columnIndex],
    })),
  }))

  return (
    <Table>
      {hasHeader && (
        <TableHead>
          <TableRow>
            {block.columns.map((column) => (
              <TableCell
                key={`${column.label}-${column.align}`}
                align={alignForColumn(column)}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.key}>
            {row.cells.map(({ cell, column }) => (
              <TableCell
                key={`${column?.label}-${cell}`}
                align={alignForColumn(column)}
              >
                <span className='fs-mask'>
                  <ConversationRichText content={cell} />
                </span>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
